class PlugNavMenuItem extends HTMLElement {
  constructor() {
    super();
    this.l2Menu = this.querySelector('.plug-header__l2-menu');
    this.l1Link = this.querySelector('.plug-header__l1-link');

    if (this.l2Menu) {
      let closeTimer;
      this.l1Link.addEventListener('mouseenter', () => {
        clearTimeout(closeTimer);
        this.open();
      });

      this.l1Link.addEventListener('mouseleave', () => {
        closeTimer = setTimeout(() => {
          this.close();
        }, 100);
      });

      this.l2Menu.addEventListener('mouseenter', () => {
        clearTimeout(closeTimer);
      });

      this.l2Menu.addEventListener('mouseleave', () => {
        closeTimer = setTimeout(() => {
          this.close();
        }, 100);
      });
    }
  }

  open() {
    const navMenuItems = document.getElementsByTagName('plug-nav-menu-item');
    let k = 0;
    while (k < navMenuItems.length) {
      navMenuItems[k].close();
      k += 1;
    }

    if (this.l2Menu) {
      // this.l1Link.classList.remove('underlined-on-hover-link');
      // this.l1Link.classList.add('underlined-link');
      this.l2Menu.classList.remove('hidden');
      window.requestAnimationFrame(() => {
        setTimeout(() => {
          this.l2Menu.classList.add('is-open');
        });
      });
    }
  }

  close() {
    if (this.l2Menu) {
      // this.l1Link.classList.remove('underlined-link');
      // this.l1Link.classList.add('underlined-on-hover-link');
      this.l2Menu.classList.add('hidden');
      this.l2Menu.classList.remove('is-open');
    }
  }

}

customElements.define('plug-nav-menu-item', PlugNavMenuItem);
